
import { SVGProps } from 'react';

const ContactUsArrow = ({
    ...otherProps
}: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="20" viewBox="0 0 8 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.690774 0.99087C0.238369 1.30765 0.128421 1.93119 0.445198 2.3836L5.7782 9.99991L0.445094 17.6164C0.128316 18.0688 0.238264 18.6923 0.690669 19.0091C1.14307 19.3259 1.76662 19.2159 2.0834 18.7635L7.78033 10.6275C7.94034 10.4282 8.01595 10.1763 7.99747 9.92676C7.98306 9.72788 7.90954 9.53444 7.78189 9.37459L2.0835 1.23645C1.76673 0.784041 1.14318 0.674093 0.690774 0.99087Z" fill="#00AEC7" />
    </svg>
);

export default ContactUsArrow;




